'use strict';
const env = {
    "url": process.env.REVIEW_API_URL || "http://localhost:8080",
    "questionUrl": process.env.QUESTION_API_URL || "http://localhost:8083",
    "configurationUrl": process.env.CONFIG_API_URL || "http://localhost:8081",
    "V3_API_URL": process.env.LOGIN_COMPONENT_URL || "https://forms-eu.unileversolutions.com/v3",
    "baseUrl": process.env.WIDGET_URL || "http://localhost:3000",
    "optinUrl": process.env.OPTIN_API_URL || "https://config.unileversolutions.com/config/optin",
    "ALLOW_ORIGIN": (process.env.ALLOW_ORIGIN && process.env.ALLOW_ORIGIN.split(",").map(url => new RegExp(url))) || [],
    "nonCachedExtention": ["js", "gif", "png", "svg", "jpg", "jpeg"],
    "projectId": process.env.WIDGET_MEDIA_PROJECTID || "jbvjmd8a",
    "dataset": process.env.WIDGET_MEDIA_DATASET || "imageupload",
    "token": process.env.WIDGET_MEDIA_TOKEN || "skpGPu9F8kodbuYaFuei5FgZbMVoSSWtxDpoG4frCeCEqFgrlAw2YNzVyFWFsmhC8hr0G15SxFvNUmkgowoRSwH22dN4sRGiZh0Kn6rGb3WUGnuZf2ru9iLCd58Dx3E1m6SBvmi3gmiaTFmQUxEFeqVSdedsULdkawFwQvI7MoGvNzVi2Krm",
    "imageUploadCount": 6
}
module.exports = env;
